import { DASHBOARD_EVENT } from "../constants/app-data.constants";
import { GridDataFilterSettings } from "../constants/grid-data-filter.constants";
import { SESSION_STORAGE_KEY_PREFIXES } from "../constants/session-storage.constants";

import { QuestionPath } from "./config-data-parser";

import { ResponseParserService } from "../services/response-parser.service";
import { AppDataService } from "../services/app-data.service";

export class GridDataFilterHandler<TFilterRequest> {

  private initialFilterRequest: TFilterRequest;

  constructor(
    private responseParserService: ResponseParserService,
    private appDataService: AppDataService,
    private getModel: () => any,
    private settings: GridDataFilterSettings<TFilterRequest>) {
  }

  getInitialFilterRequest(): TFilterRequest {
    return this.initialFilterRequest;
  }

  setInitialFilterRequest(): void {
    const filterFromSessionStorage = this.getFromSessionStorage();
    if (filterFromSessionStorage) {
      this.initialFilterRequest = filterFromSessionStorage;
    }
    else {
      const defaultFilterRequest = this.settings.getDefaultFilterRequest();
      if (defaultFilterRequest) {
        this.initialFilterRequest = defaultFilterRequest;
      }
    }
  }

  getFilterRequest(): TFilterRequest {
    const searchQuestionModel = this.getQuestionModel(this.settings.searchQuestionPath);
    const filterQuestionModel = this.getQuestionModel(this.settings.filterQuestionPath);
    const filterRequest = this.settings.getFilterRequestFromModels(searchQuestionModel, filterQuestionModel);
    return filterRequest;
  }

  saveFilterRequest(filterAction: string): TFilterRequest {
    if (filterAction === DASHBOARD_EVENT.filter.clear) {
      this.setQuestionModel(this.settings.searchQuestionPath, null);
      this.setQuestionModel(this.settings.filterQuestionPath, null);
    }
    const filterRequest = this.getFilterRequest();
    this.setIntoSessionStorage(filterRequest);
    return filterRequest;
  }

  private getQuestionModel(questionPath: QuestionPath): any {
    if (!questionPath) {
      return null;
    }
    const [navTabNumber, pageNumber, sectionCode, questionCode] = questionPath;
    const questionModel = this.responseParserService.findQuestionModel(this.getModel(), navTabNumber, pageNumber, null, sectionCode, null, questionCode);
    return questionModel;
  }

  private setQuestionModel(questionPath: QuestionPath, newQuestionModel: any): boolean {
    if (!questionPath) {
      return false;
    }
    const [navTabNumber, pageNumber, sectionCode, questionCode] = questionPath;
    const success = this.responseParserService.replaceQuestionModel(this.getModel(), navTabNumber, pageNumber, null, sectionCode, null, questionCode, newQuestionModel);
    return success;
  }

  private getFromSessionStorage(): TFilterRequest {
    return this.appDataService.getFromSessionStorage<string, TFilterRequest>(this.getSessionStorageKey());
  }

  private setIntoSessionStorage(filterRequest: TFilterRequest): void {
    this.appDataService.setIntoSessionStorage<string, TFilterRequest>(this.getSessionStorageKey(), filterRequest);
  }

  private getSessionStorageKey(): string {
    const userKey = this.settings.getLoggedInUserEmail();
    const filterKey = this.settings.getFilterName();
    const sessionStorageKey = `${SESSION_STORAGE_KEY_PREFIXES.gridServer}-${userKey}-${filterKey}`;
    return sessionStorageKey;
  }
}
